import React from "react";
import { Hearts } from  'react-loader-spinner';

export default function LoaderSpiner (){
    return (
    
        <Hearts 
  height="50"
  width="50"
  color="#black"
  ariaLabel="hearts-loading"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
/>
       
 
    
    )
}